import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {SvgIconComponent} from "../svg-icon/svg-icon.component";
import {ButtonType} from "./button-type.enum";

@Component({
  selector: 'app-fancy-button',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    SvgIconComponent,
    NgClass
  ],
  templateUrl: './fancy-button.component.html',
  styleUrl: './fancy-button.component.scss'
})
export class FancyButtonComponent {
  @Input() public type?: ButtonType = undefined;
  @Input() public icon: string = "";
  @Input() public title: string = "";
  @Input() public text: string = "";
  @Input() public selected: boolean = false;
  @Output() public selectedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() public disabled: boolean = false;
  protected readonly ButtonType = ButtonType;
}
